export default __webpack_public_path__ + "static/108-e881a5af6d7bdd61f5aad601ba425401.jpg";